export const formatTestDuration = (time?: string | null, fallback = '10') => {
  const raw = String(time ?? fallback)
    .trim()
    .replace(/\s*(min(?:ute)?s?\.?)\s*$/i, '');

  return `${raw} min`;
};
